
/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
 (function () {

  // 変数
  var rul = {}; // ルール
  var msg = {}; // メッセージ
  var glp = {}; // エラーメッセージのグループ設定

  // グローバル変数　※先にjs/validation/common.jsを読み込んでおく
  var getMsg = window.ohValidateGetMsg; // メッセージリスト
  var changeBlank = window.ohValidateChangeBlank; // 空白変換関数
  var changeHankaku = window.ohValidateChangehankaku; // 半角変換関数

  // 名前
  // バリデーション前にvalue変更
  rul['name_sei'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    maxlength: 40
  };
  msg['name_sei'] = {
    required:getMsg('required','名前（姓）'),
    maxlength:getMsg('max.string', '名前（姓）', {'max' : '40'}),
  };

  rul['name_mei'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    maxlength: 40
  };
  msg['name_mei'] = {
    required:getMsg('required','名前（名）'),
    maxlength:getMsg('max.string', '名前（名）', {'max' : '40'}),
  };

  // ふりがな
  rul['kana_sei'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    kana: true,
    maxlength: 40
  };
  msg['kana_sei'] = {
    required:getMsg('required','ふりがな(姓)'),
    kana:getMsg('kana', 'ふりがな(姓)'),
    maxlength:getMsg('max.string', 'ふりがな(姓)', {'max' : '40'})
  };

  rul['kana_mei'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    kana: true,
    maxlength: 40
  };
  msg['kana_mei'] = {
    required:getMsg('required','ふりがな(名)'),
    kana:getMsg('kana', 'ふりがな(名)'),
    maxlength:getMsg('max.string', 'ふりがな(名)', {'max' : '40'})
  };

  // 生年月日
  rul['birthday_year'] = { required: true };
  msg['birthday_year'] = { required: getMsg('required', '生年月日（年）') };

  rul['birthday_month'] = { required: true };
  msg['birthday_month'] = { required: getMsg('required', '生年月日（月）') };

  rul['birthday_day'] = { required: true, valid_date: true };
  msg['birthday_day'] = { required: getMsg('required', '生年月日（日）'), valid_date: '正しい日付を入力してください' };

  // 性別
  rul['gender'] = { required: true };
  msg['gender'] = { required: getMsg('required', '性別') };

  // ご希望のご連絡方法
  rul['contact_way[1]'] = { require_from_group: [1, '.contact_way-group'] };
  rul['contact_way[2]'] = { require_from_group: [1, '.contact_way-group'] };
  var contactWayMsg = getMsg('required', 'ご希望のご連絡方法');
  msg['contact_way[1]'] = { require_from_group: contactWayMsg };
  msg['contact_way[2]'] = { require_from_group: contactWayMsg };
  glp['contact_way'] = 'contact_way[1] contact_way[2]';

  // トリム,空白,半角に自動変換
  // 電話番号
  rul['tel_no'] = {
    required: {
      depends:function(){
        $(this).val($.trim($(this).val()));
        $(this).val(changeBlank($(this).val()));
        $(this).val(changeHankaku($(this).val()));
        return true;
      }
    },
    regex: '^(0{1}\\d{1,4}-{0,1}\\d{1,4}-{0,1}\\d{1,4})$',
    maxlength: 13
  };
  msg['tel_no'] = {
    required:getMsg('required','電話番号',),
    regex:getMsg('regex','電話番号'),
    maxlength:getMsg('max.string', '電話番号', {'max' : '13'}),
  };

  // ご希望連絡時間帯（プルダウンのためバリデーションなし）

  // メールアドレス
  // ajaxでバリデートする場合、remoteにURLを指定
  // 現行では全角文字を半角に変換した後にバリデートを掛けているが、その部分をphpコード（validate-email）に追加実装
  rul['email'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-dns",
  };
  msg['email'] = {
    required:getMsg('required','メールアドレス'),
    maxlength:getMsg('max.string', 'メールアドレス', {'max' : '60'}),
    remote:getMsg('email_dns','メールアドレス'),
  };

  // 履歴書
  rul['resume'] = {
    required: { depends: function() { return !$('input[name="resume_path"]').val(); } },
    extension: 'pdf',
    filesize: 10485760
  };
  msg['resume'] = {
    required: '履歴書は必須です',
    extension: 'PDFファイルを選択してください',
    filesize: 'ファイルサイズは10MB以内にしてください'
  };

  // 職務経歴書
  rul['work_history'] = {
    required: { depends: function() { return !$('input[name="work_history_path"]').val(); } },
    extension: 'pdf',
    filesize: 10485760
  };
  msg['work_history'] = {
    required: '職務経歴書は必須です',
    extension: 'PDFファイルを選択してください',
    filesize: 'ファイルサイズは10MB以内にしてください'
  };

  // 個人情報保護方針（プライバシー・ポリシー）
  rul['privacy_policy'] = { required: true};
  msg['privacy_policy'] = { required: getMsg('required','個人情報保護方針（プライバシー・ポリシー）') };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());

/**
 * ファイルアップロードのバリデーション有効化
 * jQuery Validateのデフォルトでは display:none の要素を無視するため、
 * file input を対象に含めるよう設定を上書きする
 */
$(function() {
  $('form').validate().settings.ignore = ':hidden:not(.c-form-upload__input)';
});
